import { render, staticRenderFns } from "./VNavbar.vue?vue&type=template&id=caea44b8"
import script from "./VNavbar.vue?vue&type=script&lang=ts"
export * from "./VNavbar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports